import { render, staticRenderFns } from "./video-material.vue?vue&type=template&id=08cc675b&scoped=true&"
import script from "./video-material.vue?vue&type=script&lang=js&"
export * from "./video-material.vue?vue&type=script&lang=js&"
import style0 from "./video-material.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./video-material.vue?vue&type=style&index=1&id=08cc675b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc675b",
  null
  
)

export default component.exports